 function applyDiscount(quantity, button) {
    // remove active class from all buttons
    const allButtons = document.querySelectorAll('.quantity-buttons .btn-custom');
    allButtons.forEach(btn => btn.classList.remove('active'));

    // add active class to the clicked button
    button.classList.add('active');

    // update the shopify quantity input
    const quantityInput = document.querySelector('input[name="quantity"]');
    if (quantityInput) {
      quantityInput.value = quantity;
    }

    console.log(`Updated quantity to: ${quantity}`);
  }

